var exports = {
  "kL": "x9997bc76--79899b--container",
  "WO": "x9997bc76--79899b--container-bottom",
  "iE": "x9997bc76--79899b--wrapper",
  "um": "x9997bc76--79899b--wrapper-bottom",
  "DD": "x9997bc76--79899b--title",
  "Qs": "x9997bc76--79899b--content",
  "IM": "x9997bc76--79899b--content-bottom",
  "lZ": "x9997bc76--79899b--phone",
  "$t": "x9997bc76--79899b--phone-bottom",
  "x6": "x9997bc76--79899b--button",
};

module.exports = exports;
